import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpRequest } from '@angular/common/http';



@Component({
  selector: 'app-personalized-offer',
  templateUrl: './personalized-offer.component.html',
  styleUrls: ['./personalized-offer.component.scss']
})
export class PersonalizedOfferComponent implements OnInit {

  personalizedForm;
  public contactUsMassage = false;
  public contactUsErrorMassage = false;

  constructor(private formBuilder: FormBuilder,  private http: HttpClient) { }

  ngOnInit() {
    this.personalizedForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phoneNumber: ['', Validators.required]
    });
  }

  onSubmit() {
    let baseAPI;

    const headers = new Headers({ 'Content-Type': 'application/json; charset=UTF-8' });

    baseAPI = 'https://api.rebodata.net/benutechApi.php?method=notify&';

    this.http.post(baseAPI +
      'email=' + this.personalizedForm.value.email + '&name='
      + this.personalizedForm.value.name + '&content=' + this.personalizedForm.value.phoneNumber, headers)
      .subscribe(
        data  => {
        }
      );
    this.contactUsMassage = true;
    this.personalizedForm.reset();
  }
}



// WEBPACK FOOTER //
// /Users/muhammadfarhan/Documents/benutech/benutechv2/client/src/app/shared/personalized-offer/personalized-offer.component.ts